import React, {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import Api from "./services/Api";
import WebConstant from "./WebConstant";
import {getCbLoginCookieValue, isValidUrl} from "./utility/IamLoginUtils";
import DOMPurify from "dompurify";

const Login = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    console.log("searchParams", searchParams);
    //const [loading, setLoading] = React.useState(true);

    // Check if the sign-on policy is valid
    const isAllowedSignOnPolicy = (signOnPolicy) => {
        if (
            signOnPolicy &&
            typeof signOnPolicy === "string" &&
            signOnPolicy.trim() !== ""
        ) {
            return Object.values(WebConstant.SignOnPolicyEnumValues).includes(signOnPolicy);
        }
        return true;
    };

    // Get the sign-on policy from query params
    const getSignOnPolicy = (searchParams) => {
        const signOnPolicy = searchParams.get(WebConstant.SIGN_ON_POLICY);
        if (
            !signOnPolicy ||
            signOnPolicy.trim() === "" ||
            !isAllowedSignOnPolicy(signOnPolicy)
        ) {
            return WebConstant.SignOnPolicyEnumValues.DEFAULT;
        }
        return signOnPolicy;
    };

    useEffect(() => {
        async function isLoggedIn(appId) {
            const cbLoginCookieValue = getCbLoginCookieValue();
            if (!cbLoginCookieValue || cbLoginCookieValue.trim() === "") {
                return false;
            }

            try {
                const unifiedSession = await Api.getUnifiedSession(cbLoginCookieValue, Number(WebConstant.IAM_APP_ID));
                if (unifiedSession) {
                    if (unifiedSession.namespace === "csr") {
                        return false;
                    }
                    if (unifiedSession.accountId) {
                        return true;
                    }
                }
            } catch (e) {
                //mslogin will throw 500 error if it gets failed response from bsauth
                //console.error(e);
            }
            return false;
        }

        const sendToOkta = async () => {
            //get query parameter from url for  signOnPolicy
            const urlParams = new URLSearchParams(window.location.search);
            let signOnPolicy = getSignOnPolicy(urlParams);
            const flow = urlParams.get(WebConstant.FLOW);
            const fromAction = urlParams.get(WebConstant.FROM_ACTION);
            const skipEnroll = urlParams.get(WebConstant.SKIPENROLL);
            const idp = urlParams.get(WebConstant.SSO_IDP);

            //get DURL from query parameter
            const durl =
                urlParams.get(WebConstant.DURL) ||
                urlParams.get(WebConstant.DESTINATION_PAGE);
            if (durl) {
                let isValid = isValidUrl(durl);
                if (isValid) {
                    sessionStorage.setItem(WebConstant.DURL, durl);
                }else {
                    sessionStorage.removeItem(WebConstant.DURL);
                }
            } else {
                sessionStorage.removeItem(WebConstant.DURL);
            }

            //get appId from query parameter
            const appId =
                urlParams.get(WebConstant.SSO_APP_ID) ||
                urlParams.get(WebConstant.SSO_APPLICATION_ID);
            if (appId) {
                sessionStorage.setItem(WebConstant.SSO_APP_ID, appId);
            } else {
                sessionStorage.removeItem(WebConstant.SSO_APP_ID);
            }

            if (fromAction) {
                sessionStorage.setItem(WebConstant.FROM_ACTION, fromAction);
            }else {
                sessionStorage.removeItem(WebConstant.FROM_ACTION);
            }

            if (skipEnroll) {
                sessionStorage.setItem(WebConstant.SKIPENROLL, skipEnroll);
            }else {
                sessionStorage.removeItem(WebConstant.SKIPENROLL);
            }

            if (idp) {
                sessionStorage.setItem(WebConstant.IDP, idp.toUpperCase());
            }else {
                sessionStorage.removeItem(WebConstant.IDP);
            }

            //checkHeader(urlParams, true);
            let authRequest = {};

            if (flow) {
                sessionStorage.setItem(WebConstant.FLOW, flow);
            }else {
                sessionStorage.removeItem(WebConstant.FLOW);
            }
            sessionStorage.setItem(WebConstant.IS_VERIFY, false);

            if (await isLoggedIn()) {
                sessionStorage.setItem(WebConstant.IS_VERIFY, true);

                // honor the policy passed in; if no policy passed in, default to VERIFY
                if (signOnPolicy == null || signOnPolicy === WebConstant.SignOnPolicyEnumValues.DEFAULT) {
                    signOnPolicy = WebConstant.SignOnPolicyEnumValues.VERIFY;
                }
            }

            authRequest.signOnPolicy = signOnPolicy;
            sessionStorage.setItem(WebConstant.SIGN_ON_POLICY, signOnPolicy);

            //send to okta for authentication
            let result = await Api.getOktaLoginURL(authRequest);
            console.log("result", result);
            if (result) {
                console.log("result.authURL", result.authUrl);
                if (result.nonce) {
                    sessionStorage.setItem(WebConstant.NONCE, result.nonce);
                }
                window.location.href = result.authUrl;
            } else {
                // setLoading(false);
            }
        };

        sendToOkta().catch(error => {
            console.error("Error during login process sendToOkta", error);
            navigate("/login/error");
        });
    }, []);

    // Render a loading state while the token exchange happens
    /* return (
      <div className="login">
        {loading ? <h2>Processing authentication...</h2> : <div></div>}
      </div>
    ); */
    return null;
};
export default Login;
